import { fetch } from "../../../appContainer";
import {
  GET_ANALYSIS_LIST_IN_PROGRESS,
  GET_ANALYSIS_LIST_SUCCESS,
  GET_ANALYSIS_LIST_FAIL,
  MARK_ANALYSIS_AS_VIEWED_SUCCESS,
} from "../constants";

export function getAnalysisList() {
  return (dispatch) => {
    dispatch({ type: GET_ANALYSIS_LIST_IN_PROGRESS });

    fetch("api").getAnalysisList(
      (list) => {
        dispatch({ type: GET_ANALYSIS_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_ANALYSIS_LIST_FAIL })
    );
  };
}

export function markAnalysisAsViewed(uuid) {
  return (dispatch) => {
    fetch("api").markAnalysisAsViewed(
      uuid,
      () => {
        dispatch({ type: MARK_ANALYSIS_AS_VIEWED_SUCCESS, payload: { uuid } });
      },
      () => {}
    );
  };
}
